module.exports = __webpack_public_path__ + "img/HAPPE_80X30.b4d50542.png";